export function unwrapApiResponse(response) {
  const body = response.data;

  if (!body || typeof body !== "object") {
    throw new Error("Invalid response from server");
  }

  if (!body.success) {
    const detail =
      Array.isArray(body.errors) && body.errors.length
        ? body.errors.join(", ")
        : null;
    throw new Error(detail || body.message || "Request failed");
  }

  return body.data;
}

export function getApiErrorMessage(error) {
  const body = error?.response?.data;
  if (body && typeof body === "object") {
    if (Array.isArray(body.errors) && body.errors.length) {
      return body.errors.join(", ");
    }
    if (body.message) return body.message;
  }
  return error?.message || "Request failed";
}
